"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import Managerment from "@/views/managements/Managerment.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import LoginLogs from "./components/LoginLogs.vue";
import LoginLogsAdvancedSearch from "./components/LoginLogsAdvancedSearch.vue";
import ManagerLogs from "./components/ManagerLogs.vue";
import AccessLogs from "./components/AccessLogs.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, { MenuController } from "@/components/menu/ManagerMenuBar.vue";
import RiskLogs from "./components/RiskLogs.vue";
import ShopRiskLogs from "./components/ShopRiskLogs.vue";
import TeamLogs from "./components/TeamLogs.vue";
import VirtualDesktopTrafficDetail from "@/views/virtual-desktop/VirtualDesktopTrafficDetail.vue";
import i18n from "@/lang";
let LogsManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "LoginLogs",
          icon_image: "log_sidebar_1",
          name: i18n.t("accesslogs.login_logs_sidebar")
        },
        {
          index: "ManageLogs",
          icon_image: "log_sidebar_2",
          name: i18n.t("accesslogs.manage_logs_sidebar")
        },
        {
          index: "AccessLogs",
          icon_image: "log_sidebar_3",
          name: i18n.t("accesslogs.access_logs_sidebar")
        },
        {
          index: "RiskLogs",
          icon_image: "log_sidebar_4",
          name: i18n.t("accesslogs.risk_logs_sidebar")
        },
        {
          index: "ShopLogs",
          icon_image: "log_sidebar_5",
          name: i18n.t("accesslogs.shop_risk_logs_sidebar")
        },
        {
          index: "TeamLogs",
          icon_image: "log_sidebar_5",
          name: i18n.t("accesslogs.team_logs_sidebar")
        },
        {
          index: "VirtualDesktopTrafficDetail",
          icon_image: "log_sidebar_5",
          name: i18n.t("accesslogs.virtual_desktop_traffic_detail_sidebar")
        }
      ],
      "LoginLogs"
    );
    this.currentGroup = "";
  }
  changeTeamComponent(data) {
    if (data) {
      this.currentGroup = data;
    }
  }
  changeCollapse() {
  }
  created() {
    return __async(this, null, function* () {
      this.currentGroup = "LoginLogs";
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a;
      if (((_a = this.$session) == null ? void 0 : _a.type) !== "account") {
        this.menu_controller = new MenuController(
          false,
          [
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_LOGIN_LOG")) {
                return [
                  {
                    index: "LoginLogs",
                    icon_image: "log_sidebar_1",
                    name: i18n.t("accesslogs.login_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_MANAGEMENT_LOG")) {
                return [
                  {
                    index: "ManageLogs",
                    icon_image: "log_sidebar_2",
                    name: i18n.t("accesslogs.manage_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_VISIT_LOG")) {
                return [
                  {
                    index: "AccessLogs",
                    icon_image: "log_sidebar_3",
                    name: i18n.t("accesslogs.access_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_RISK_LOG")) {
                return [
                  {
                    index: "RiskLogs",
                    icon_image: "log_sidebar_4",
                    name: i18n.t("accesslogs.risk_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_ACCOUNT_LOGIN_LOG")) {
                return [
                  {
                    index: "ShopLogs",
                    icon_image: "log_sidebar_5",
                    name: i18n.t("accesslogs.shop_risk_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_TEAM_LOG")) {
                return [
                  {
                    index: "TeamLogs",
                    icon_image: "log_sidebar_5",
                    name: i18n.t("accesslogs.team_logs_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              var _a2;
              if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.any("SHOW_ALL_MENUS", "VIEW_TRAFFIC_LOG")) {
                return [
                  {
                    index: "VirtualDesktopTrafficDetail",
                    icon_image: "log_sidebar_5",
                    name: i18n.t("accesslogs.virtual_desktop_traffic_detail_sidebar")
                  }
                ];
              } else {
                return [];
              }
            })()
          ],
          (() => {
            var _a2, _b, _c, _d, _e, _f, _g;
            if ((_a2 = this.$session) == null ? void 0 : _a2.permissions.is("VIEW_LOGIN_LOG")) {
              return "LoginLogs";
            } else if ((_b = this.$session) == null ? void 0 : _b.permissions.is("VIEW_MANAGEMENT_LOG")) {
              return "ManageLogs";
            } else if ((_c = this.$session) == null ? void 0 : _c.permissions.is("VIEW_VISIT_LOG")) {
              return "AccessLogs";
            } else if ((_d = this.$session) == null ? void 0 : _d.permissions.is("VIEW_RISK_LOG")) {
              return "RiskLogs";
            } else if ((_e = this.$session) == null ? void 0 : _e.permissions.is("VIEW_ACCOUNT_LOGIN_LOG")) {
              return "ShopLogs";
            } else if ((_f = this.$session) == null ? void 0 : _f.permissions.is("VIEW_TEAM_LOG")) {
              return "TeamLogs";
            } else if ((_g = this.$session) == null ? void 0 : _g.permissions.is("VIEW_TRAFFIC_LOG")) {
              return "VirtualDesktopTrafficDetail";
            } else {
              return "LoginLogs";
            }
          })()
        );
        this.currentGroup = this.menu_controller.default_components;
      } else {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "LoginLogs",
              icon_image: "log_sidebar_1",
              name: i18n.t("accesslogs.login_logs_sidebar")
            },
            {
              index: "ManageLogs",
              icon_image: "log_sidebar_2",
              name: i18n.t("accesslogs.manage_logs_sidebar")
            },
            {
              index: "AccessLogs",
              icon_image: "log_sidebar_3",
              name: i18n.t("accesslogs.access_logs_sidebar")
            },
            {
              index: "RiskLogs",
              icon_image: "log_sidebar_4",
              name: i18n.t("accesslogs.risk_logs_sidebar")
            },
            {
              index: "ShopLogs",
              icon_image: "log_sidebar_5",
              name: i18n.t("accesslogs.shop_risk_logs_sidebar")
            },
            {
              index: "TeamLogs",
              icon_image: "log_sidebar_5",
              name: i18n.t("accesslogs.team_logs_sidebar")
            },
            {
              index: "VirtualDesktopTrafficDetail",
              icon_image: "log_sidebar_5",
              name: i18n.t("accesslogs.virtual_desktop_traffic_detail_sidebar")
            }
          ],
          "LoginLogs"
        );
        this.currentGroup = "LoginLogs";
      }
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.currentGroup = _index.index;
        }
      }
    });
  }
};
LogsManager = __decorateClass([
  Component({
    components: {
      MenuItem,
      Managerment,
      LoginLogs,
      LoginLogsAdvancedSearch,
      MainView,
      UiMenuBar,
      ManagerLogs,
      AccessLogs,
      RiskLogs,
      ShopRiskLogs,
      TeamLogs,
      VirtualDesktopTrafficDetail
    }
  })
], LogsManager);
export {
  LogsManager as default
};
